import React, { FC } from 'react';
import { useTranslations } from '@lang';
import { Arrow, ButtonContent, ContentWrapper, StyledButton } from './MoreDetailsButton.styles';

type MoreDetailsButtonProps = {
  details: string;
  featured: boolean;
  isShowingDetails: boolean;
  showDetails: () => void;
  hideDetails: () => void;
  isWiderViewport: boolean;
};

export const MoreDetailsButton: FC<MoreDetailsButtonProps> = ({
  details,
  featured,
  isShowingDetails,
  showDetails,
  hideDetails,
  isWiderViewport,
}) => {
  const { t } = useTranslations();

  if (featured && isWiderViewport) {
    return null;
  }

  if (!details) {
    return <div />;
  }

  return (
    <StyledButton onClick={isShowingDetails ? hideDetails : showDetails} type="button">
      <ContentWrapper>
        <ButtonContent>
          {t(isShowingDetails ? 'common.moreInfoButtonHide' : 'common.moreDetails')}
        </ButtonContent>
        <Arrow isShowingDetails={isShowingDetails} />
      </ContentWrapper>
    </StyledButton>
  );
};
